import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentsService } from '../../services/documents.service';
import { DocumentacionService } from 'app/modules/company-view/services/documentacion.service';


@Component({
    selector: 'app-document-view-container',
    templateUrl: './document-view-container.component.html',
    styleUrls: ['./document-view-container.component.scss'],
    standalone: false
})
export class DocumentViewContainerComponent implements OnInit {

  IsLoading: boolean = true;

  DocumentId: string;
  Option: string;
  pdfSrc: any;

  // Image
  Image: boolean = true;
  Pdf: boolean = true;
  docNotFound: boolean;


  constructor(
    public route: ActivatedRoute,
    public dialogRef: MatDialogRef<DocumentViewContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public InputData: any,
    public documentService: DocumentsService,
    private _documentacionService: DocumentacionService,
  ) { }

  ngOnInit(): void {
    this.DocumentId = this.InputData.EmployeeDocId;
    this.Option = this.InputData.Type.toString();
    if (this.Option === '1') {           // Employee Document.
      this.ViewEmployeeDocument();
    } else if (this.Option === '2') {   // Leave document with document
      this.ViewLeaveDocument();
    } else if (this.Option === '3') {   // Leave document with recording.
      this.ViewLeaveRecording();
    } else if (this.Option === '4') {   // Empresa document
      this.ViewEmpresaViewDocuments();
    }
    this.docNotFound = false;
  }

  private ViewEmpresaViewDocuments(): void {    
    if(this.DocumentId == null || this.DocumentId == undefined || this.DocumentId == '' )
        return

    this._documentacionService.GetDocEmpresaDocumentByDocumentId(Number(this.DocumentId))
      .subscribe(res => {
        if (res.result.tipoDocumento === 'JPG' || res.result.tipoDocumento === 'PNG' || res.result.tipoDocumento === 'BMP' || res.result.tipoDocumento === 'TIF') {
          this.Pdf = false;
          const imag = new Image();
          if (res.result.tipoDocumento === 'TIF') {
            imag.src = `data:image/tiff;base64,${res.result.documento}`;
          }
          else {
            imag.src = `data:image/jpeg;base64,${res.result.documento}`;
          }
          document.getElementById('imageHolder').appendChild(imag);

        } else if (res.result.tipoDocumento === 'PDF') {
          this.Image = false;
          this.pdfSrc = this.ConvertBase64ToUnit8Array(res.result.documento);
        }else if (res.result.documentType === 'Doc') {
          //this method doesent support word documents
          this.IsLoading = false;
          this.docNotFound = true;          
        }

        this.IsLoading = false;
      }, err => {
        this.docNotFound = true;
        console.error(err);
      });
  }

  private ViewEmployeeDocument(): void {
    this.documentService.GetEmployeeDocument(this.DocumentId)
      .subscribe(res => {
        if (res.result.documentType === 'JPG' || res.result.documentType === 'PNG' || res.result.documentType === 'BMP' || res.result.documentType === 'TIF') {
          this.Pdf = false;
          const imag = new Image();
          if (res.result.documentType === 'TIF') {
            imag.src = `data:image/tiff;base64,${res.result.document}`;
          }
          else {
            imag.src = `data:image/jpeg;base64,${res.result.document}`;
          }
          document.getElementById('imageHolder').appendChild(imag);

        } else if (res.result.documentType === 'PDF') {
          this.Image = false;
          this.pdfSrc = this.ConvertBase64ToUnit8Array(res.result.document);
        }
        this.IsLoading = false;
      }, err => {
        this.docNotFound = true;
        console.error(err);
      });
  }

  private ViewLeaveDocument(): void {
    this.documentService.getLeavePdfDocument(this.DocumentId)
      .subscribe(res => {
        if (res.result !== null && res.result.pdf !== null && res.result.pdf !== '') {
          this.Image = false;
          this.pdfSrc = this.ConvertBase64ToUnit8Array(res.result.pdf);
        } else {
          this.docNotFound = true;
        }
        this.IsLoading = false;
      });
  }

  private ViewLeaveRecording(): void {
    this.documentService.getLeaveRecording(this.DocumentId)
      .subscribe(res => {
        if (res.result !== null && res.result.grabacion !== null) {
          this.Pdf = false;
          const audio = new Audio();
          audio.autoplay = true;
          audio.controls = true;
          audio.src = `data:audio/wav;base64,${res.result.grabacion}`;
          audio.load();
          document.getElementById('imageHolder').appendChild(audio);
        } else {
          this.docNotFound = true;
        }
        this.IsLoading = false;
      });
  }

  private ConvertBase64ToUnit8Array(input: string): Uint8Array {
    return new Uint8Array(atob(input).split('').map(this.charCodeAt));
  }

  private charCodeAt(c): any {
    return c.charCodeAt(0);
  }

  public ClosePanel(): void {
    this.dialogRef.close();
  }
}
